import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const CHECKOUTS_FEATURE_GROUP: FeatureGroup = {
  guid: '1aa51e03-0388-45c9-9230-46e6d554ff00',
  name: 'checkouts',
  description: 'Checkouts app — sell tickets and memberships through hosted checkout flows',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
